import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { links } from '[theme-lib]/links';

import BaseCheckoutBtn from 'lib/apps/header/components/CheckoutButton';

import { reportCheckoutButtonClicked } from 'lib/apps/header/actions/checkoutButton';
import { priceFormat } from 'lib/apps/products/utils/priceFormat';
import shopControlsVisibilities from 'lib/apps/header/utils/shopControlsVisibilities';

const CheckoutButton = (props) => {
  const { basket, className, isAlternativeHeader, router, shopControlsVisibility } = props;

  if (shopControlsVisibility !== shopControlsVisibilities.SLOT_BOOKING_AND_CHECKOUT) {
    return null;
  }

  if (!isAlternativeHeader) {
    return (<BaseCheckoutBtn {...props} />);
  }

  const buttonClassNames = classNames(
    className,
    'hd-checkoutBtn',
    'continue',
    { 'hd-checkoutBtn--disabled': !basket.checkoutAllowed }
  );

  return (
    <Link
      to={links.CHECKOUT}
      onClick={onCheckoutButtonClick(router, basket)}
      className={buttonClassNames}
    >
      Checkout
      { !basket.checkoutAllowed && (
        <span className="hd-checkoutBtn__minOrder">
          Minimum spend of {
            priceFormat({ value: basket.minimumOrderValue, zeroAfterPound: false, inPound: true })
          }
        </span>
      )}
    </Link>
  );
};

// Handle checkout button click event
function onCheckoutButtonClick(router, basket) {
  return (e) => {
    const redirect = () => router.push({
      pathname: links.CHECKOUT,
    });

    e.preventDefault();
    if (basket.checkoutAllowed) {
      reportCheckoutButtonClicked('DESKTOP_HEADER', redirect);
    }
  };
}

CheckoutButton.propTypes = {
  basket: PropTypes.shape({
    checkoutAllowed: PropTypes.bool.isRequired,
    minimumOrderValue: PropTypes.number.isRequired,
  }).isRequired,
  className: PropTypes.string,
  isAlternativeHeader: PropTypes.bool.isRequired,
  shopControlsVisibility: PropTypes.string.isRequired,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

CheckoutButton.defaultProps = {
  className: '',
};

export default CheckoutButton;
